import { accountPageRoutes } from '../account/routes';
import { accountRoute } from '../accounts/routes';
import { activityRoutes } from '../activity/routes';
import { addOnsRoutes } from '../add-ons/routes';
import { alertsRoutes } from '../alerts/routes';
import { assetsRoutes } from '../assets/routes';
import { ProtectedRoute } from '../auth/components/protectedRoute';
import { campaignsRoutes } from '../campaigns/routes';
import { featuresRoute } from '../features/routes';
import { filesRoutes } from '../files/routes';
import { groupsRoutes } from '../groups/routes';
import { newRoutinesRoutes } from '../new-routines/routes';
import { productsRoutes } from '../products/routes';
import { profileRoutes } from '../profile/routes';
import { routinesRoutes } from '../routines/routes';
import { settingsRoutes } from '../settings/routes';
import { tagRoutes } from '../tags/routes';
import { workspaceRoute } from '../workspaces/routes';

export const dashboardRoutes = [
  {
    path: '/',
    element: <ProtectedRoute />,
    handle: {
      requiredPermission: 'none',
    },
    children: [
      ...accountRoute,
      ...activityRoutes,
      ...addOnsRoutes,
      ...alertsRoutes,
      ...assetsRoutes,
      ...campaignsRoutes,
      ...groupsRoutes,
      ...routinesRoutes,
      ...newRoutinesRoutes,
      ...productsRoutes,
      ...settingsRoutes,
      ...tagRoutes,
      featuresRoute,
      ...profileRoutes,
      ...accountPageRoutes,
      ...workspaceRoute,
      ...filesRoutes,
    ],
  },
];
